export default "__VITE_ASSET__BmRxIuEY__"